import { Component, OnInit, Input } from '@angular/core';
import { Settings } from '../../model/settings.model';
import { ToastService } from '../../service/toast.service';
import { ParametersService } from '../../service/parameters.service';

@Component({
  selector: 'app-parameters-accessibility',
  templateUrl: './parameters-accessibility.component.html',
  styleUrls: ['./parameters-accessibility.component.less']
})
export class ParametersAccessibilityComponent implements OnInit {
  @Input() settings: Settings;
  @Input() company: boolean;
  timerEvent: NodeJS.Timer;
  isSuperAdmin = false
  constructor(private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService) {
    this.isSuperAdmin = this._parametersService.isSuperAdmin

  }

  ngOnInit() {
    if (this.settings && this.settings.accessibility) {
      if (this.settings.accessibility.showIcons === undefined)
        this.settings.accessibility.showIcons = false;
      if (this.settings.accessibility.useFastTrack === undefined)
        this.settings.accessibility.useFastTrack = false;
      if (this.settings.accessibility.fastTrackComp === undefined)
        this.settings.accessibility.fastTrackComp = false;
      if (this.settings.accessibility.fastTrackZoom === undefined)
        this.settings.accessibility.fastTrackZoom = true;
      if (this.settings.accessibility.fastTrackL1 === undefined)
        this.settings.accessibility.fastTrackL1 = true;
      if (this.settings.accessibility.fastTrackL2 === undefined)
        this.settings.accessibility.fastTrackL2 = true;
      if (this.settings.accessibility.fastTrackL3 === undefined)
        this.settings.accessibility.fastTrackL3 = true;
      if (this.settings.accessibility.showImmatPicture === undefined)
        this.settings.accessibility.showImmatPicture = true;
    }
  }

  test(a){
    console.log('aaaaaaaaaa',a);
  }
  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._parametersService.saveAccessibility(this.settings.accessibility, this.company).then((saved: Settings) => {
        this.settings.accessibility = saved.accessibility;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/element/parameters-accessibility/parameters-accessibility.component.ts